<template>
  <div class="nav-header-container">
    <div class="logo">
      <div class="imgs"><img src="../assets/image/logo@2x(1).png" alt="竞争力"></div>
      <div class="right">
        <img src="../assets/image/life_gray.png" alt="">添加微信送小初高资料
        <img src="../assets/image/weixin.png" alt="" class="img-se">官方微信
      </div>
    </div>
    <div class="nav-box">
      <div class="nav-list">
        <div :class="{active: queryInfo.currentNav == 1}" @click="goNav(1)">首页</div>
        <div :class="{active: queryInfo.currentNav == 2}" @click="goNav(2)">小学</div>
        <div :class="{active: queryInfo.currentNav == 3}" @click="goNav(3)">初中</div>
        <div :class="{active: queryInfo.currentNav == 4}" @click="goNav(4)">高中</div>
        <div :class="{active: queryInfo.currentNav == 5}" @click="goNav(5)">中考</div>
        <div :class="{active: queryInfo.currentNav == 6}" @click="goNav(6)">高考</div>
        <div :class="{active: queryInfo.currentNav == 7}" @click="goNav(7)">课程</div>
        <div :class="{active: queryInfo.currentNav == 8}" @click="goNav(8)">校区查询</div>
        <div :class="{active: queryInfo.currentNav == 9}" @click="goNav(9)">加入我们</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      queryInfo:{
        currentNav: 1
      }
    }
  },
  methods:{
      goNav(num){
         this.queryInfo.currentNav = num;
         if(num==1){
            this.$router.push("/");
         }
         if(num==7){
            this.$router.push("/course")
         }
         if(num==8){
            this.$router.push("/campus")
         }
      }
  },
}
</script>

<style scoped lang="less">
  .nav-header-container {
    width: 100%;
    .logo {
      width: 62%;
      display: flex;
      justify-content: space-between;
      align-items: flex-end;
      margin: 50px auto 30px;
      .imgs {
        width: 233px;
        img {
          width: 100%;
        }
      }
      .right {
        display: flex;
        align-items: center;
        font-size: 18px;
        color: #737479;
        margin-bottom: 5px;
        img {
          width: 23px;
          margin-right: 10px;
        }
        .img-se {
          width: 25px;
          margin: 0 6px 0 25px;
        }
      }
    }
    .nav-box {
      width: 100%;
      height: 62px;
      background-color: #1361CF;
      .nav-list {
        width: 65%;
        height: 100%;
        margin: 0 auto;
        display: flex;
        align-items: center;
        justify-content: space-between;
        div {
          font-size: 20px;
          color: #fff;
          line-height: 62px;
          padding: 0 35px;
          cursor: pointer;
          &.active {
            background-color: #0C53B1;
          }
        }
      }
    }
  }
</style>
